import * as React from 'react';
var DEFAULTS = {
    getIcon: function (name) { return null; },
    getIconPath: function (name) { return null; }
};
var Context = React.createContext(DEFAULTS);
export var BrandProvider = function (props) {
    return React.createElement(Context.Provider, { value: props.config || DEFAULTS }, props.children);
};
BrandProvider.displayName = 'BrandProvider';
export var useBrand = function () { return React.useContext(Context); };
//# sourceMappingURL=brand-context.js.map